import { IRootState } from '../../../store'
import { ITripInformationOptionsState } from '../store/options.types'

export const getTripInformationOptionsSelector = (state: IRootState): ITripInformationOptionsState =>
  state.options.tripInformationOptions
